export function formatHeat(heat: number): string {
  if (heat >= 10000) return `${(heat / 10000).toFixed(1)}万`;
  return `${heat}`;
}

export function formatCount(count: number): string {
  if (count >= 10000) return `${(count / 10000).toFixed(1)}万`;
  return `${count}`;
}